import { baseApi } from './baseApi';
import type { InboxSummary } from './types';

/** The Inbox badge (sidebar, Dashboard bell) and the Notifications tile counts. */
const inboxSummaryApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    inboxSummary: build.query<
      InboxSummary,
      { period?: string | undefined; from?: string | undefined; to?: string | undefined } | undefined
    >({
      query: (params) => ({ url: '/notifications/summary', params: params ?? {} }),
      providesTags: ['InboxSummary'],
    }),
  }),
});

export const { useInboxSummaryQuery } = inboxSummaryApi;
